import React from 'react'
import {useQuery} from "react-query";
import {GetCacheKey} from "../../../services/common/utils";
import { redirecturl } from '../../../services/common/redirect';
import { useNavigate } from 'react-router-dom';
import RoamingHomeBannerShimmer from '../../../ShimmerEffect/RoaminghomePageBanner';

function RoamingPacksBanner({ pmsitem }) {
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError
    } = useQuery([GetCacheKey("roaming_packs_banner"), pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}], {
        retry: false,
        retryOnMount: false,
    });
    const navigate = useNavigate();
    if (isLoading || isFetching) {
        return (
            <RoamingHomeBannerShimmer message={"Loading"} />
        );
    }

    return (
        <div className='banner_section_new sprint14_banner_section_new' onClick={()=> {redirecturl(data?.response[0]?.banners[0]?.url, navigate)}}  style={{ backgroundColor: pmsitem?.elementmeta?.bgcolor}}>
            <div className='banners_item'>
                <div className='w-60'>
                    <h3>{pmsitem?.elementmeta?.showtitle === "T"? pmsitem?.elementmeta?.title : ""}</h3>
                </div>
                <div className='img_cont'>
                    <img src={ data?.response[0]?.banners[0]?.path+"?t="+data?.response[0]?.banners[0]?.updateddate} alt="" title="" />
                </div>
            </div>
        </div>
    )
}

export default RoamingPacksBanner;
